module.exports = __webpack_public_path__ + "07_mustache_black.045fc6a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/07_mustache_black.png
// module id = tYTr
// module chunks = 0